<template>
    <div class="component__details">
        <h2 class="component__details_title">{{ $t('shared.components.title.details') }}</h2>
        <ul class="component__details_list">
            <li class="component__details_list_item">
                <div class="columns is-variable">
                    <div class="column is-narrow">
                        <div class="component__details_list_item_label">{{ $t('shared.components.title.capacity') }}</div>
                    </div>
                    <div class="column has-text-right">
                        <div class="component__details_list_item_value">{{capacity}} {{ $t('shared.components.title.people') }}</div>
                    </div>
                </div>
            </li>
            <li class="component__details_list_item">
                <div class="columns is-variable">
                    <div class="column is-narrow">
                        <div class="component__details_list_item_label">{{ $t('shared.components.title.cost') }}</div>
                    </div>
                    <div class="column has-text-right">
                        <div class="component__details_list_item_value">{{costOutput}} {{ $t('shared.components.title.per') }} {{costPeriod}}</div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'component-details',
  props: {
    capacity: {
      type: [Number, String],
      default: 0
    },
    cost: {
      type: [Number, String],
      default: 0
    },
    costPeriod: {
      type: String,
      default: ''
    }
  },
  computed: {
    costOutput () {
      const costValue = this.cost / 100
      return costValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })
    }
  }
}
</script>

<style lang="scss">
    @import '~@/assets/scss/components/default/shared/componentdetails';
</style>
